export default {"src":"/_next/static/media/shopping_bag.37d9724a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};